import React, { useEffect, useState } from 'react';

const COUNTDOWN_SECONDS = 60;

const InactivityWarning = ({ onStayLoggedIn, onLogout }) => {
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (countdown <= 0) {
      onLogout();
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, onLogout]);

  return (
    <>
      <style>{`
        .inactivity-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .inactivity-modal {
          background: hsl(var(--card));
          border: 1px solid hsl(var(--border));
          border-radius: var(--radius-lg);
          padding: 32px;
          max-width: 400px;
          width: 90%;
          box-shadow: var(--shadow-lg);
          text-align: center;
        }
        .inactivity-icon {
          font-size: 40px;
          margin-bottom: 16px;
        }
        .inactivity-title {
          font-size: 18px;
          font-weight: 700;
          color: hsl(var(--foreground));
          margin-bottom: 8px;
        }
        .inactivity-message {
          font-size: 14px;
          color: hsl(var(--muted-foreground));
          margin-bottom: 8px;
        }
        .inactivity-countdown {
          font-size: 28px;
          font-weight: 800;
          color: hsl(var(--destructive));
          margin-bottom: 24px;
        }
        .inactivity-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
        }
        .btn-stay {
          padding: 10px 24px;
          border-radius: var(--radius-md);
          border: none;
          background: var(--gradient-primary);
          color: white;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          font-family: inherit;
        }
        .btn-logout {
          padding: 10px 24px;
          border-radius: var(--radius-md);
          border: 1px solid hsl(var(--border));
          background: transparent;
          color: hsl(var(--foreground));
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          font-family: inherit;
        }
      `}</style>
      <div className="inactivity-overlay">
        <div className="inactivity-modal">
          <div className="inactivity-icon">⏱️</div>
          <div className="inactivity-title">Session Expiring Soon</div>
          <div className="inactivity-message">
            You've been inactive. You will be logged out in
          </div>
          <div className="inactivity-countdown">{countdown}s</div>
          <div className="inactivity-actions">
            <button className="btn-stay" onClick={onStayLoggedIn}>
              Stay Logged In
            </button>
            <button className="btn-logout" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactivityWarning;
